<template>
  <span>
    <span v-for="item in data"
          v-if="value == item.id"
          :key="item.id">
      {{ item.label }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'EspEnumView',
  data() {
    return {}
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    value: {
      type: Number,
      default: -100
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/enum/EspEnumView.vue